import { ArrowUpRight, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

type PageHeaderProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  icon?: LucideIcon;
  action?: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
};

const PageHeader = ({
  eyebrow,
  title,
  description,
  icon: Icon,
  action,
  actionLabel,
  onAction,
}: PageHeaderProps) => {
  return (
    <header className="page-header">
      <div className="page-header-copy min-w-0">
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <div className="mt-1 flex items-center gap-3">
          {Icon ? (
            <span className="page-header-icon" aria-hidden="true">
              <Icon className="h-5 w-5" />
            </span>
          ) : null}
          <h1 className="page-title">{title}</h1>
        </div>
        {description ? <p className="page-description">{description}</p> : null}
      </div>
      <div className="page-header-actions">
        {action ? action : null}
        {!action && actionLabel && onAction ? (
          <button type="button" className="button-primary" onClick={onAction}>
            {actionLabel}
            <ArrowUpRight className="h-4 w-4" />
          </button>
        ) : null}
      </div>
    </header>
  );
};

export default PageHeader;
